import React from 'react';
import PropTypes from 'prop-types';
import DynamicScaleSlider from '../DynamicScaleSlider/DynamicScaleSlider';
import ShopAllButton from '../ShopAllButton/ShopAllButton';

export default function MaterialCard({
  fabricImage,
  fabricImageAltText,
  fabricType,
  fabricDescription,
  scaleData,
  shopAllLabel,
  brand,
  isSelect,
  onClick,
  isMobile = false,
}) {
  return (
    <div className="material-card">
      <img
        src={fabricImage}
        alt={fabricImageAltText}
        className={`material-card__image ${isSelect ? 'material-card__image--selected' : ''}`}
        aria-label={isSelect ? `${fabricImageAltText}, currently selected` : fabricImageAltText}
      />
      <div className="material-card__content">
        <h1 className="h1">{fabricType}</h1>
        <p className="material-card__description">{fabricDescription}</p>
        {scaleData?.length > 0 && scaleData.map((scale) => (
          <DynamicScaleSlider
            key={scale.scaleType}
            scaleType={scale.scaleType}
            minLabelForScale={scale.minLabelForScale}
            maxLabelForScale={scale.maxLabelForScale}
            attributeLevel={scale.attributeLevel}
            currentMeasurement={scale.currentMeasurement}
            aria-label={`${scale.scaleType}: ${scale.levelValue}`}
          />
        ))}
        <ShopAllButton
          onClick={onClick}
          shopAllLabel={shopAllLabel}
          brand={brand}
          aria-label={`${shopAllLabel} ${fabricType}`}
          isMobile={isMobile}
        />
      </div>
    </div>
  );
}

MaterialCard.propTypes = {
  fabricImage: PropTypes.string.isRequired,
  fabricImageAltText: PropTypes.string.isRequired,
  fabricType: PropTypes.string.isRequired,
  fabricDescription: PropTypes.string.isRequired,
  shopAllLabel: PropTypes.string.isRequired,
  brand: PropTypes.string.isRequired,
  isSelect: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
};
